import { GlobalPeriodSelect, globalSearchShortcutLabel, globalSearchTriggerDataId } from '@components'

import { Flex, IconButton, Space, Tooltip } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { CustomEvent } from '../../../../enums/customEvent'
import { PeriodMode } from '../../../../enums/periodMode'
import { useSegment } from '../../../../hooks'
import { dispatchCustomEvent } from '../../../../utils/customEvent'
import * as Styled from './styles'

export const DashboardActions = (): ReactElement => {
  const { track } = useSegment()
  const { t } = useTranslation()

  const handleSearchButtonClick = useCallback(() => {
    track('xxx - design - Globalsearch click', {
      trigger: 'button',
    })

    dispatchCustomEvent(CustomEvent.GlobalSearchButtonClicked)
  }, [track])

  return (
    <Flex alignItems="center">
      <Tooltip label={`${t('search')} (${globalSearchShortcutLabel})`} placement="top">
        <Styled.SearchIconButtonWrapper>
          <IconButton
            size="md"
            icon="search"
            onClick={handleSearchButtonClick}
            title={`${t('search')} (${globalSearchShortcutLabel})`}
            data-id={globalSearchTriggerDataId}
          />
        </Styled.SearchIconButtonWrapper>
      </Tooltip>
      <Space size="s16" horizontal />
      <GlobalPeriodSelect
        disabledPeriodModes={[PeriodMode.All, PeriodMode.Month, PeriodMode.Quarter, PeriodMode.CustomDate]}
        placement="bottom-end"
      />
    </Flex>
  )
}
